import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { FC, useState } from "react";

interface Props {
  target: CompanyDTO | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteCompanyDialog: FC<Props> = ({ target, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    onConfirm().finally(() => setLoading(false));
  };

  return (
    <Dialog open={!!target} onClose={onClose}>
      <DialogTitle>Supprimer l&apos;entreprise</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Êtes-vous sûr de vouloir supprimer <strong>{target?.name}</strong> ? Cette action est irréversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button color="error" variant="contained" onClick={handleConfirm} disabled={loading}>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCompanyDialog;
